{
  "name": "@ns/company-hmrc-trust-score-review",
  "version": "1.0.0",
  "description": "Refresh the HMRC part of your company's trust score: connect HMRC again if asked, then run the trust score",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
